/** @jsxRuntime classic */
/** @jsx jsx */
//@ts-nocheck
import * as React from 'react';
import { jsx } from '@emotion/react';

export function FeeIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
      <g fill="none" fillRule="evenodd">
        <rect width="40" height="40" fill="#444340" fillRule="nonzero" rx="5" />
        <g stroke="#EAE8E5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.35">
          <path d="M15 23.5h4M25 23.5h1M29 19.5H11M27.8 27H12.2c-.662 0-1.2-.53-1.2-1.182V15.182c0-.653.538-1.182 1.2-1.182h15.6c.662 0 1.2.53 1.2 1.182v10.636c0 .653-.538 1.182-1.2 1.182z" />
        </g>
      </g>
    </svg>
  );
}
export function EditIconDocument({...props}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" {...props}>
      <g fill="none" fillRule="evenodd">
        <rect width="40" height="40" fill="#444340" fillRule="nonzero" rx="5" transform="translate(0 .611)" />
        <g stroke="#EAE8E5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.35">
          <path d="M25 19l-4-4M12.5 27.5l1-5 10-10 4 4-10 10z" />
        </g>
      </g>
    </svg>
  );
}

export function UnlockIcon({ stroke = 'currentColor', fill = 'currentColor' }) {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
      <g strokeLinecap="square" strokeLinejoin="miter" strokeWidth="2" fill={fill} stroke={stroke}>
        <path
          data-cap="butt"
          fill="none"
          stroke={stroke}
          strokeMiterlimit="10"
          d="M16.6,4C15.8,2.2,14,1,12,1h0 C9.2,1,7,3.2,7,6v3"
          strokeLinecap="butt"
        />
        <circle dataColor="color-2" fill="none" strokeMiterlimit="10" cx="12" cy="15" r="2" />
        <line dataColor="color-2" fill="none" strokeMiterlimit="10" x1="12" y1="17" x2="12" y2="19" />
        <rect x="4" y="9" fill="none" stroke={stroke} strokeMiterlimit="10" width="16" height="14" />
      </g>
    </svg>
  );
}
export function PhoneIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd" stroke="#93918F" strokeLinecap="round" strokeLinejoin="round">
        <path strokeWidth="1.3" d="M12 10l-2 2-6-6 2-2-3-3-2 2c0 6.627 5.373 12 12 12l2-2-3-3z" />
        <path d="M8.5 4A3.5 3.5 0 0 1 12 7.5" />
        <path strokeWidth="1.3" d="M8.5 1A6.5 6.5 0 0 1 15 7.5" />
      </g>
    </svg>
  );
}

export function ZoomIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41">
      <g fill="none" fillRule="evenodd" transform="translate(0 .766)">
        <rect width="40" height="40" fill="#F9F8F7" fillRule="nonzero" rx="5" />
        <path
          stroke="#EEA61A"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
          d="M28 28l-3.2-3.2"
        />
        <circle
          cx="18.4"
          cy="18.4"
          r="6.4"
          stroke="#EEA61A"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
        <path
          stroke="#EEA61A"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
          d="M18.4 16v4.8M20.8 18.4H16"
        />
      </g>
    </svg>
  );
}
export function EmptyIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <path
        fill="#EEA61A"
        fillRule="nonzero"
        d="M7.998 0c4.411 0 8 3.589 8 8s-3.589 8-8 8c-4.41 0-8-3.589-8-8s3.59-8 8-8zm5.135 3.849l-9.286 9.286a6.574 6.574 0 0 0 4.151 1.474A6.616 6.616 0 0 0 14.607 8a6.574 6.574 0 0 0-1.474-4.151zM7.998 1.39A6.616 6.616 0 0 0 1.39 8c0 1.572.553 3.016 1.473 4.151l9.287-9.286a6.574 6.574 0 0 0-4.152-1.474z"
      />
    </svg>
  );
}
export function DownloadIcon({ stroke, background, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" {...props}>
      <g fill="none" fillRule="evenodd" transform="translate(0 .766)">
        <rect width="40" height="40" fill={background || '#F9F8F7'} fillRule="nonzero" rx="5" />
        <path
          stroke={stroke || '#EEA61A'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
          d="M12.5 22.91v4.363h14.545v-4.364M19.773 12v10.91M15.41 18.545l4.363 4.364 4.363-4.364"
        />
      </g>
    </svg>
  );
}

export function PreviewIcon() {
  return (
    <svg width="19px" height="17px" viewBox="0 0 19 17" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Order-Info" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
        <g
          transform="translate(-1283.000000, -173.000000)"
          id="folder-search"
          stroke="#EAE8E5"
          strokeWidth="1.35"
        >
          <g transform="translate(1284.000000, 174.000000)">
            <path d="M13.5,11.5 L16,14" id="Path" />
            <circle id="Oval" cx="11.5" cy="9.5" r="2.5" />
            <path
              d="M12.3636364,15 L1.54545455,15 C0.691923568,15 0,14.3284271 0,13.5 L0,0 L6.18181818,0 L8.5,3 L17,3 L17,10.5"
              id="Path"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
export function EditIcon({ ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" {...props}>
      <g fill="none" fillRule="evenodd">
        <rect width="40" height="40" fill="#444340" fillRule="nonzero" rx="5" />
        <g stroke="#EAE8E5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.4">
          <path d="M26.413 21.74v5.564H12.5V12h12.522" />
          <path d="M20.848 23.13H18.76v-2.087l6.26-6.26 2.088 2.087z" />
        </g>
      </g>
    </svg>
  );
}

// stroke={'#93918F'}
export function ClientsIcon({ currentColor }) {
  return (
    <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="users-mm-copy"
          transform="translate(1.000000, 1.000000)"
          stroke="currentColor"
          strokeWidth="1.35"
        >
          <path
            d="M10.2025,12.3000175 L7.4932,11.4924129 C7.28443827,11.4300556 7.13017033,11.2447517 7.0994,11.0193874 L6.8717,9.33841625 C8.04553229,8.77575373 8.7989023,7.54701289 8.8,6.19337342 L8.8,4.60816107 C8.82771732,2.70106439 7.41675602,1.11025663 5.6012,1.00162993 C4.70858597,0.972905982 3.84298222,1.32484282 3.20204855,1.977076 C2.56111487,2.62930917 2.19957997,3.52614514 2.2,4.46279226 L2.2,6.19337342 C2.2010977,7.54701289 2.95446771,8.77575373 4.1283,9.33841625 L3.9006,11.0147725 C3.86982967,11.2401368 3.71556173,11.4254407 3.5068,11.4877981 L0.7975,12.2954026 C0.325595256,12.4369725 0.000218052942,12.8893286 0,13.4041283 L0,16 L11,16 L11,13.4087431 C10.9997819,12.8939435 10.6744047,12.4415873 10.2025,12.3000175 Z"
            id="Path"
          />
          <path
            d="M12.5714286,16 L16,16 L16,12.3215205 C16,11.7973693 15.6433498,11.3404316 15.1348571,11.2130629 L11.8011429,10.3800056 C11.5753955,10.3236781 11.4063456,10.1361153 11.3737143,9.90576855 L11.1394286,8.25908047 C12.3589946,7.70177329 13.1417167,6.48472744 13.1428571,5.14397172 L13.1428571,3.57384721 C13.1716544,1.684902 11.7057205,0.109235334 9.81942857,0.00164253433 C9.18224702,-0.0180842718 8.5521833,0.140206943 8,0.458738462"
            id="Path"
          />
        </g>
      </g>
    </svg>
  );
}
export function MunicipalitiesIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 18 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="house" transform="translate(1.000000, 1.000000)" stroke={stroke} strokeWidth="1.35">
          <polygon
            id="Path"
            points="8 0 0 7.46666667 0 16 6.15384615 16 6.15384615 11.7333333 9.84615385 11.7333333 9.84615385 16 16 16 16 7.46666667"
          />
        </g>
      </g>
    </svg>
  );
}

// stroke='#93918F'
export function TaxingIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 18 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="police" transform="translate(1.000000, 1.000000)" stroke={stroke} strokeWidth="1.35">
          <polygon id="Path" points="8 0.5 15.5 3.5 13.5 6.5 13.5 8.5 2.5 8.5 2.5 6.5 0.5 3.5" />
          <path
            d="M13.5,8.5 L13.5,10 C13.5,13.0375661 11.0375661,15.5 8,15.5 L8,15.5 C4.96243388,15.5 2.5,13.0375661 2.5,10 L2.5,8.5"
            id="Path"
          />
        </g>
      </g>
    </svg>
  );
}
export function TagIcon({ width = 16, height = 16, stroke = 'currentColor', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={width}
      height={height}
      stroke={stroke}
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
        transform="translate(0 -.006)"
      >
        <path d="M9.108 15.215l6.139-6.14L7.061.89H.922v6.14z" />
        <circle cx="5.015" cy="4.983" r="1.364" />
      </g>
    </svg>
  );
}
// hover color for tag is #FADEAE
export function LargeTagIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
        transform="translate(1 .17)"
      >
        <path d="M9.927 17.95l7.338-7.338L7.48.828H.142v7.338z" />
        <circle cx="5.034" cy="5.72" r="1.631" />
      </g>
    </svg>
  );
}
export function PaperClipIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <path
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        d="M8.857 5.357L5.852 8.362a1.75 1.75 0 0 0 2.475 2.475l4.066-4.066a3.5 3.5 0 1 0-4.95-4.95l-4.42 4.42a5.25 5.25 0 0 0 7.426 7.425L14.514 9.6"
      />
    </svg>
  );
}

export function PrintIcon({ width = 16, height = 16, stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18 18" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
      >
        <path d="M3.823 4.948V1.265h10.312v3.683M3.823 13.787H.877V4.948h16.205v8.84h-2.947" />
        <path d="M3.823 9.368h10.312v8.102H3.823z" />
      </g>
    </svg>
  );
}

export function LargePrintIcon({ width = 16, height = 16, stroke = 'currentColor', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      stroke={stroke}
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
      >
        <path d="M3.823 4.948V1.265h10.312v3.683M3.823 13.787H.877V4.948h16.205v8.84h-2.947" />
        <path d="M3.823 9.368h10.312v8.102H3.823z" />
      </g>
    </svg>
  );
}

//base color is #444340
export function XIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
      >
        <path d="M8.974 1.5L1.508 8.969M8.974 8.968L1.508 1.5" />
      </g>
    </svg>
  );
}

// base color #93918F
export function XIconLarge({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <path d="M16.906 1.088L1.094 16.9M16.906 16.9L1.094 1.088" />
      </g>
    </svg>
  );
}

//base color is #CCC9C6
export function DownCarotIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" {...props}>
      <path
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        d="M8 2L4 6 0 2"
      />
    </svg>
  );
}

//base color is #CCC9C6
export function RightCarotIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" {...props}>
      <path
        fill="none"
        fillRule="evenodd"
        stroke="#CCC9C6"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        d="M2 0l4 4-4 4"
      />
    </svg>
  );
}

export function TrashCanIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
      >
        <path d="M14.19 7.001v9.74H3.06V7M.973 4.218h15.304M8.625 9.088v4.174M5.842 9.088v4.174M11.408 9.088v4.174M5.842 4.218V1.436h5.566v2.782" />
      </g>
    </svg>
  );
}

export function ViewedIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg viewBox="0 0 24 24" width="24" height="24" {...props}>
      <path
        fill="#FADEAE"
        d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
      ></path>
    </svg>
  );
}

// base fill is #CCC9C6
export function DownCarotFullIcon({ fill = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" {...props}>
      <path
        fill={fill}
        fillRule="nonzero"
        d="M7.6 1.2H.4a.4.4 0 0 0-.32.64l3.6 4.8a.4.4 0 0 0 .64 0l3.6-4.8a.4.4 0 0 0-.32-.64z"
      />
    </svg>
  );
}

// base color is stroke='#FADEAE',
export function CheckIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 11 11" {...props}>
      <path
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
        d="M0 4.75l3.5 3.5 6.5-6.5"
      />
    </svg>
  );
}

// base color is stroke='#444340',
export function SearchGlassIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
        transform="translate(0 .511)"
      >
        <path d="M13.254 12.74l-3.98-3.981" />
        <circle cx="5.724" cy="5.21" r="5.02" />
      </g>
    </svg>
  );
}

// base color is stroke='#fff',
export function PlusIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      >
        <path d="M10.166.697v16.465M18.856 8.93H1.476" />
      </g>
    </svg>
  );
}

// base color is stroke='#444340',
export function LargeSearchGlassIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
        transform="translate(0 .465)"
      >
        <path d="M15.147 14.56l-4.549-4.55" />
        <circle cx="6.542" cy="5.954" r="5.737" />
      </g>
    </svg>
  );
}

// base color is stroke='#EEA61A',
export function CompletedIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
      >
        <path d="M.7 10.163l2.738 2.738 8.214-10.267M15.074 6.056h-2.053M15.074 12.901h-7.53M15.074 9.479h-4.791" />
      </g>
    </svg>
  );
}

// base color is stroke='#EEA61A',
export function DataEntryIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
      >
        <path d="M9.028 8.533V1.576M14.593 2.272h2.087v9.739H1.376V2.27h2.087M5.55 16.185h6.956M9.028 12.01v4.175" />
        <path d="M6.245 4.359l2.783-2.783 2.783 2.783" />
      </g>
    </svg>
  );
}

// base color is stroke='#EEA61A',
export function MultipleIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
      >
        <path d="M1.038 5.823h8.348v9.739H1.038z" />
        <path d="M3.82 3.04h8.348v9.74" />
        <path d="M6.603.258h8.348v9.74" />
      </g>
    </svg>
  );
}

// base color is stroke='#EEA61A',
export function OrdersIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
      >
        <path d="M1.381 1.375h5.333v5.333H1.381zM1.381 11.28h5.333v5.333H1.381zM10.524 2.137h6.095M10.524 5.947h6.095M10.524 12.042h6.095M10.524 15.851h6.095" />
      </g>
    </svg>
  );
}

// base color is stroke='#EEA61A',
export function FolderIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
      >
        <path d="M2.455 16.088h12.363L17 6.633H4.636z" />
        <path d="M14.09 3.724H7.546L6.091 1.542H1v11.636" />
      </g>
    </svg>
  );
}

// base color is stroke='#EEA61A',
export function MailIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
      >
        <path d="M14.369 14.5h-13a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1z" />
        <path d="M2.369 4.5l5.5 4.5 5.5-4.5" />
      </g>
    </svg>
  );
}

// base color is stroke='#EEA61A',
export function RequestedIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...props}>
      <path
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
        d="M.307 1h15.305v10.435H8.655l-4.87 3.478v-3.478H.308z"
      />
    </svg>
  );
}

// base color is stroke='#EEA61A',
export function InProgressIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          stroke="#EEA61A"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.35"
          d="M1.533 7.47a7.622 7.622 0 0 1 12.802-3.916M12.048 5.185l3.81-3.81.761 4.572z"
        />
        <path fill="#EEA61A" d="M12.048 5.185l3.81-3.81.761 4.572z" />
        <path
          stroke="#EEA61A"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.35"
          d="M16.467 10.518a7.622 7.622 0 0 1-12.802 3.916M5.952 12.804l-3.81 3.81-.761-4.572z"
        />
        <path fill="#EEA61A" d="M5.952 12.804l-3.81 3.81-.761-4.572z" />
      </g>
    </svg>
  );
}

// base color is stroke='#33322F',
export function FaceIcon({ stroke = 'currentColor', fill = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" {...props}>
      <g fill="none" fillRule="evenodd" transform="translate(1 .994)">
        <path
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.35"
          d="M.383 7.258c2.218-2.957 6.139.423 10.4-3.432C12.87 7.13 15.62 7.302 15.62 7.302"
        />
        <circle cx="4.87" cy="9.739" r="1.043" fill={fill} fillRule="nonzero" />
        <circle cx="11.13" cy="9.739" r="1.043" fill={fill} fillRule="nonzero" />
        <circle
          cx="8"
          cy="8"
          r="7.652"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.35"
        />
      </g>
    </svg>
  );
}

// base color is stroke='#93918F',
export function AddressBookIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
        transform="translate(1 -.006)"
      >
        <rect width="13" height="15" y=".973" rx="1" />
        <path d="M3 3.973h7v4H3zM15 2.973v2M15 6.973v2" />
      </g>
    </svg>
  );
}

export function LockIcon({ ...props }) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0)">
        <path
          d="M13.5396 7.71289H3.45997C2.66471 7.71289 2.02002 8.35758 2.02002 9.15284V14.1927C2.02002 14.9879 2.66471 15.6326 3.45997 15.6326H13.5396C14.3349 15.6326 14.9796 14.9879 14.9796 14.1927V9.15284C14.9796 8.35758 14.3349 7.71289 13.5396 7.71289Z"
          stroke="#FADEAE"
          strokeWidth="1.43995"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.90039 7.71221V4.8323C4.90039 3.87756 5.27966 2.96191 5.95477 2.2868C6.62988 1.61169 7.54553 1.23242 8.50027 1.23242C9.45502 1.23242 10.3707 1.61169 11.0458 2.2868C11.7209 2.96191 12.1002 3.87756 12.1002 4.8323V7.71221"
          stroke="#FADEAE"
          strokeWidth="1.43995"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white" transform="translate(0.5 0.432617)" />
        </clipPath>
      </defs>
    </svg>
  );
}

// base color is stroke='#93918F',
export function SentArrowIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
      >
        <path d="M16.6 1.394l-8.8 8.8M16.6 1.394l-5.6 15.2-3.2-6.4-6.4-3.2z" />
      </g>
    </svg>
  );
}

// base color is stroke='#93918F',
export function SettingsIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
        transform="translate(0 .5)"
      >
        <path d="M9.05 3.04h6.26M.006 3.04h2.087M14.615 8.605h.695M.006 8.605h7.652M9.05 14.17h6.26M.006 14.17h2.087" />
        <circle cx="4.18" cy="3.04" r="2.087" />
        <circle cx="9.745" cy="8.605" r="2.087" />
        <circle cx="4.18" cy="14.171" r="2.087" />
      </g>
    </svg>
  );
}

// base color is stroke='#FADEAE',
export function RushIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
      <path
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.35"
        d="M11 1.17l-10 11h9l-1 7 10-11h-9z"
      />
    </svg>
  );
}

export function SuccessIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg height="128" viewBox="0 0 104 128" width="104" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path d="m78.729 1.038h-73.2v122h97.6v-97.6z" fill="#fff" />
        <g stroke="#444340" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
          <path d="m74.329 5.038h-73.2v122h97.6v-97.6z" />
          <path d="m74.329 5.038v24.4h24.4m-48.8 20.332v32.534m16.267-16.266h-32.534" />
        </g>
      </g>
    </svg>
  );
}

export function SendIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18">
      <g
        fill="none"
        fillRule="evenodd"
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      >
        <path d="M13.19 5.16H6.333a3.048 3.048 0 0 0-3.047 3.047v4.571" />
        <path d="M9.381 8.969l3.81-3.81-3.81-3.81M16.238 12.778v3.81H1" />
      </g>
    </svg>
  );
}

export function LogoutIcon() {
  return (
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 511.989 511.989" width="24px" height="24px">
      <g>
        <path
          d="M110.933,221.782c-4.71,0-8.533,3.823-8.533,8.533v51.2c0,4.71,3.823,8.533,8.533,8.533s8.533-3.823,8.533-8.533v-51.2
C119.467,225.605,115.644,221.782,110.933,221.782z"
        />
        <path
          d="M111.855,2.304L31.172,34.586C8.448,43,0,54.418,0,76.715v358.477c0,22.298,8.448,33.715,30.959,42.061l81.058,32.427
c4.011,1.519,8.038,2.287,11.981,2.287c17.152,0,29.602-14.336,29.602-34.091V34.049C153.6,9.78,134.246-6.126,111.855,2.304z
 M136.533,477.876c0,10.18-5.035,17.024-12.535,17.024c-1.869,0-3.883-0.401-5.803-1.118L37.103,461.33
c-16.102-5.965-20.036-11.102-20.036-26.138V76.715c0-15.036,3.934-20.164,20.241-26.206l80.725-32.29
c2.082-0.785,4.087-1.186,5.956-1.186c7.501,0,12.544,6.835,12.544,17.016V477.876z"
        />
        <path
          d="M178.133,51.115h120.533c14.114,0,25.6,11.486,25.6,25.6v128c0,4.71,3.814,8.533,8.533,8.533
c4.719,0,8.533-3.823,8.533-8.533v-128c0-23.526-19.14-42.667-42.667-42.667H178.133c-4.71,0-8.533,3.823-8.533,8.533
S173.423,51.115,178.133,51.115z"
        />
        <path
          d="M332.8,298.582c-4.719,0-8.533,3.823-8.533,8.533v128c0,14.114-11.486,25.6-25.6,25.6H179.2
c-4.71,0-8.533,3.823-8.533,8.533s3.823,8.533,8.533,8.533h119.467c23.526,0,42.667-19.14,42.667-42.667v-128
C341.333,302.405,337.519,298.582,332.8,298.582z"
        />
        <path
          d="M511.343,252.655c-0.435-1.05-1.058-1.988-1.852-2.782l-85.325-85.333c-3.337-3.336-8.73-3.336-12.066,0
c-3.337,3.337-3.337,8.73,0,12.066l70.767,70.775H196.267c-4.71,0-8.533,3.823-8.533,8.533c0,4.71,3.823,8.533,8.533,8.533
h286.601L412.1,335.215c-3.337,3.337-3.337,8.73,0,12.066c1.664,1.664,3.849,2.5,6.033,2.5c2.185,0,4.369-0.836,6.033-2.5
l85.325-85.325c0.794-0.794,1.417-1.732,1.852-2.782C512.205,257.093,512.205,254.738,511.343,252.655z"
        />
      </g>
    </svg>
  );
}

export function ReportsIcon() {
  return (
    <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="paper" transform="translate(1.000000, 1.000000)" stroke="#93918F" strokeWidth="1.35">
          <line x1="3.5" y1="3.5" x2="10.5" y2="3.5" id="Path"></line>
          <line x1="3.5" y1="6.5" x2="10.5" y2="6.5" id="Path"></line>
          <line x1="3.5" y1="9.5" x2="10.5" y2="9.5" id="Path"></line>
          <path
            d="M13.5,10.5 L13.5,0.5 L0.5,0.5 L0.5,13.5 C0.5,14.605 1.395,15.5 2.5,15.5 L2.5,15.5 L2.5,15.5 C3.605,15.5 4.5,14.605 4.5,13.5 L4.5,12.5 L15.5,12.5 L15.5,13 C15.5,14.381 14.381,15.5 13,15.5 L2.5,15.5"
            id="Path"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export function PencilIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.75781 3.56152L11.3852 6.18889"
        stroke="#CCC9C6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75146 10.5679L4.37883 13.1952"
        stroke="#CCC9C6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5096 1.81006L13.137 4.43742L4.37913 13.1953L0.875977 14.0711L1.75176 10.5679L10.5096 1.81006Z"
        stroke="#CCC9C6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowleftIcon() {
  return (
    <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.859845 14.9487C1.24327 15.3321 1.86145 15.3321 2.24488 14.9487L8.74748 8.44605C9.05265 8.14088 9.05265 7.6479 8.74748 7.34272L2.24488 0.840121C1.86145 0.456695 1.24327 0.456695 0.859845 0.840121C0.476418 1.22355 0.476418 1.84173 0.859845 2.22515L6.52517 7.8983L0.85202 13.5715C0.476418 13.9471 0.476418 14.5731 0.859845 14.9487V14.9487Z"
        fill="#EEA61A"
      />
    </svg>
  );
}

export function NotesNotification() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="5.96777" cy="5.84314" r="5.68066" fill="#C50E29" />
    </svg>
  );
}
export function NotificationBell() {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0024 5.3335C12.0024 4.27263 11.581 3.25521 10.8309 2.50507C10.0807 1.75492 9.06331 1.3335 8.00244 1.3335C6.94158 1.3335 5.92416 1.75492 5.17401 2.50507C4.42387 3.25521 4.00244 4.27263 4.00244 5.3335C4.00244 10.0002 2.00244 11.3335 2.00244 11.3335H14.0024C14.0024 11.3335 12.0024 10.0002 12.0024 5.3335Z"
        stroke="#EAE8E5"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.15579 14C9.03858 14.2021 8.87035 14.3698 8.66794 14.4864C8.46553 14.6029 8.23604 14.6643 8.00245 14.6643C7.76887 14.6643 7.53938 14.6029 7.33697 14.4864C7.13456 14.3698 6.96633 14.2021 6.84912 14"
        stroke="#EAE8E5"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
export function MarkRead() {
  return (
    <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.16479 9.08079L3.90276 11.8018L12.1167 1.59814"
        stroke="#93918F"
        stroke-width="1.35"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.5391 4.99927H13.4856"
        stroke="#93918F"
        stroke-width="1.35"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.5392 11.8018H8.00977"
        stroke="#93918F"
        stroke-width="1.35"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.5392 8.40063H10.7478"
        stroke="#93918F"
        stroke-width="1.35"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
export function FaxIcon({ makeBold }) {
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.08826 3.25586H3.95191V3.57617C4.21003 3.85153 4.29375 4.05471 4.26562 4.55273V5.43555V9.93555V10.1364V10.8496H3.40196H1.74049C1.19292 10.8496 0.749023 10.4019 0.749023 9.84961V4.11523C0.749023 3.64061 1.13049 3.25586 1.60106 3.25586H3.08826ZM1.79626 4.16211C1.71412 4.16211 1.64754 4.22927 1.64754 4.31211V9.78555C1.64754 9.86839 1.71412 9.93555 1.79626 9.93555H3.24937C3.3315 9.93555 3.39809 9.86839 3.39809 9.78555V4.31211C3.39809 4.22927 3.3315 4.16211 3.24937 4.16211H1.79626Z"
        fill={makeBold ? '#33322F' : '#93918F'}
      />
      <path
        d="M3.40196 10.8496H4.26562V10.1364C4.23149 10.4502 4.03156 10.8496 3.40196 10.8496Z"
        fill={makeBold ? '#33322F' : '#93918F'}
      />
      <path
        d="M3.40196 10.8496H4.26562V10.1364C4.23149 10.4502 4.03156 10.8496 3.40196 10.8496Z"
        fill={makeBold ? '#33322F' : '#93918F'}
      />
      <path
        d="M3.40196 10.8496H4.26562V10.1364C4.23149 10.4502 4.03156 10.8496 3.40196 10.8496Z"
        fill={makeBold ? '#33322F' : '#93918F'}
      />
      <path
        d="M10.5087 5.04883C10.5087 4.77484 10.2885 4.55273 10.0169 4.55273H9.12611H4.26562V5.43555H9.477C9.55913 5.43555 9.62572 5.5027 9.62572 5.58555V9.78555C9.62572 9.86839 9.55913 9.93555 9.477 9.93555H4.26562C4.2725 9.99356 4.27365 10.0626 4.26562 10.1364V10.8496H9.51727C10.0648 10.8496 10.5087 10.4019 10.5087 9.84961V5.04883Z"
        fill={makeBold ? '#33322F' : '#93918F'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.08826 3.25586H3.95191V1.37695C3.95191 1.23888 4.06289 1.12695 4.19978 1.12695H6.32988V3.45117C6.32988 3.72731 6.55182 3.95117 6.82561 3.95117H9.12611V4.55273H10.0169V3.47461C10.0091 3.42253 9.98125 3.30352 9.93167 3.24414C9.8821 3.18477 8.10625 1.28971 7.22452 0.349609C7.18837 0.309245 7.07812 0.228516 6.9263 0.228516H4.32759C3.64312 0.228516 3.08826 0.78816 3.08826 1.47852V3.25586ZM7.22452 3.05273V1.64648L8.53356 3.05273H7.22452Z"
        fill={makeBold ? '#33322F' : '#93918F'}
      />
      <path
        d="M5.32486 7.68165C5.32486 7.45312 5.50882 7.26411 5.7354 7.26465C5.96123 7.26518 6.14402 7.45386 6.14402 7.68163C6.14402 7.91016 5.96006 8.09917 5.73348 8.09864C5.50765 8.0981 5.32486 7.90942 5.32486 7.68165Z"
        fill={makeBold ? '#33322F' : '#93918F'}
      />
      <path
        d="M5.32486 9.02564C5.32486 8.79711 5.50882 8.6081 5.7354 8.60864C5.96123 8.60918 6.14402 8.79785 6.14402 9.02563C6.14402 9.25416 5.96006 9.44317 5.73348 9.44263C5.50765 9.44209 5.32486 9.25342 5.32486 9.02564Z"
        fill={makeBold ? '#33322F' : '#93918F'}
      />
      <path
        d="M5.32486 6.3379C5.32486 6.10937 5.50882 5.92036 5.7354 5.9209C5.96123 5.92143 6.14402 6.11011 6.14402 6.33788C6.14402 6.56641 5.96006 6.75542 5.73348 6.75489C5.50765 6.75435 5.32486 6.56567 5.32486 6.3379Z"
        fill={makeBold ? '#33322F' : '#93918F'}
      />
      <path
        d="M6.66488 6.3379C6.66488 6.10937 6.84885 5.92036 7.07543 5.9209C7.30126 5.92143 7.48405 6.11011 7.48405 6.33788C7.48405 6.56641 7.30008 6.75542 7.0735 6.75489C6.84767 6.75435 6.66488 6.56567 6.66488 6.3379Z"
        fill={makeBold ? '#33322F' : '#93918F'}
      />
      <path
        d="M8.00515 6.3379C8.00515 6.10937 8.18911 5.92036 8.41569 5.9209C8.64152 5.92143 8.82431 6.11011 8.82431 6.33788C8.82431 6.56641 8.64035 6.75542 8.41377 6.75489C8.18794 6.75435 8.00515 6.56567 8.00515 6.3379Z"
        fill={makeBold ? '#33322F' : '#93918F'}
      />
      <path
        d="M8.00515 7.68165C8.00515 7.45312 8.18911 7.26411 8.41569 7.26465C8.64152 7.26518 8.82431 7.45386 8.82431 7.68163C8.82431 7.91016 8.64035 8.09917 8.41377 8.09864C8.18794 8.0981 8.00515 7.90942 8.00515 7.68165Z"
        fill={makeBold ? '#33322F' : '#93918F'}
      />
      <path
        d="M6.66488 7.68165C6.66488 7.45312 6.84885 7.26411 7.07543 7.26465C7.30126 7.26518 7.48405 7.45386 7.48405 7.68163C7.48405 7.91016 7.30008 8.09917 7.0735 8.09864C6.84767 8.0981 6.66488 7.90942 6.66488 7.68165Z"
        fill={makeBold ? '#33322F' : '#93918F'}
      />
      <path
        d="M8.00515 9.02564C8.00515 8.79711 8.18911 8.6081 8.41569 8.60864C8.64152 8.60918 8.82431 8.79785 8.82431 9.02563C8.82431 9.25416 8.64035 9.44317 8.41377 9.44263C8.18794 9.44209 8.00515 9.25342 8.00515 9.02564Z"
        fill={makeBold ? '#33322F' : '#93918F'}
      />
      <path
        d="M6.66488 9.02564C6.66488 8.79711 6.84885 8.6081 7.07543 8.60864C7.30126 8.60918 7.48405 8.79785 7.48405 9.02563C7.48405 9.25416 7.30008 9.44317 7.0735 9.44263C6.84767 9.44209 6.66488 9.25342 6.66488 9.02564Z"
        fill={makeBold ? '#33322F' : '#93918F'}
      />
    </svg>
  );
}

export function WebsiteIcon({ makeBold }) {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.4189 1.75781L5.92372 10.2428L7.16801 6.54781L10.8315 5.29281L2.4189 1.75781Z"
        stroke={makeBold ? '#33322F' : '#93918F'}
        strokeWidth={makeBold ? '1.4' : '1.1'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.37624 6.75781L10.3506 9.75781"
        stroke={makeBold ? '#33322F' : '#93918F'}
        strokeWidth={makeBold ? '1.4' : '1.1'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MailOutlookCardIcon({ makeBold }) {
  return (
    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.85597 0.732617L5.05097 0.992828C4.88908 0.880937 4.71222 0.793379 4.52607 0.732617H4.85597Z"
        fill="black"
        stroke="#93918F"
        strokeWidth="1.1"
      />
    </svg>
  );
}

export function PhoneOutlookCardIcon({ makeBold }) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.8378 8.71786V10.2179C10.8383 10.3571 10.8101 10.4949 10.7548 10.6225C10.6994 10.7501 10.6183 10.8647 10.5166 10.9588C10.4149 11.0529 10.2948 11.1246 10.164 11.1692C10.0332 11.2138 9.8946 11.2304 9.75709 11.2179C8.23165 11.0507 6.76635 10.5249 5.47893 9.68286C4.28116 8.91519 3.26566 7.89095 2.50454 6.68286C1.66674 5.37846 1.14537 3.89336 0.982646 2.34786C0.970258 2.20959 0.98655 2.07024 1.03048 1.93867C1.07442 1.80711 1.14503 1.68621 1.23783 1.58367C1.33063 1.48114 1.44358 1.39922 1.56949 1.34312C1.6954 1.28703 1.83151 1.25799 1.96915 1.25786H3.45635C3.69693 1.25547 3.93016 1.3414 4.11258 1.49963C4.29499 1.65785 4.41414 1.87758 4.44781 2.11786C4.51058 2.59789 4.62699 3.06922 4.79482 3.52286C4.86152 3.70182 4.87595 3.89632 4.83642 4.0833C4.79688 4.27028 4.70503 4.44192 4.57174 4.57786L3.94216 5.21286C4.64786 6.46463 5.67547 7.50108 6.91655 8.21286L7.54613 7.57786C7.68092 7.44343 7.85108 7.35078 8.03647 7.31091C8.22186 7.27103 8.41469 7.28559 8.59212 7.35286C9.04189 7.52214 9.5092 7.63955 9.98513 7.70286C10.2259 7.73713 10.4459 7.85946 10.6031 8.04661C10.7603 8.23375 10.8438 8.47265 10.8378 8.71786Z"
        stroke={makeBold ? '#33322F' : '#93918F'}
        strokeWidth={makeBold ? '1.4' : '1.1'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PlusSquare() {
  return (
    <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.584473" width="40" height="40" rx="5" fill="#F9F8F7" />
    </svg>
  );
}

export function OutlookCardsInfoIcon({ makeBold }) {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path
          d="M8.60856 14.6654C12.2905 14.6654 15.2752 11.6806 15.2752 7.9987C15.2752 4.3168 12.2905 1.33203 8.60856 1.33203C4.92666 1.33203 1.94189 4.3168 1.94189 7.9987C1.94189 11.6806 4.92666 14.6654 8.60856 14.6654Z"
          stroke={makeBold ? '#33322F' : '#93918F'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.60864 10.6667V8"
          stroke={makeBold ? '#33322F' : '#93918F'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.60864 5.33203H8.61357"
          stroke={makeBold ? '#33322F' : '#93918F'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white" transform="translate(0.608643)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function RequirementIcon() {
  return (
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path
          d="M5.94892 11.5371C8.68677 11.5371 10.9062 9.29853 10.9062 6.53711C10.9062 3.77569 8.68677 1.53711 5.94892 1.53711C3.21107 1.53711 0.991608 3.77569 0.991608 6.53711C0.991608 9.29853 3.21107 11.5371 5.94892 11.5371Z"
          stroke="#33322F"
          strokeWidth="1.13"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.94882 4.5376V6.5376"
          stroke="#33322F"
          strokeWidth="1.13"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.94882 8.5376H5.9539"
          stroke="#33322F"
          strokeWidth="1.13"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="11.8976" height="12" fill="white" transform="translate(6.10352e-05 0.537109)" />
        </clipPath>
      </defs>
    </svg>
  );
}

// export function RequirementIcon() {
// 	return (
// 		<svg width='2' height='5' viewBox='0 0 2 5' fill='none' xmlns='http://www.w3.org/2000/svg'>
// 			<path d='M0.705566 1.53955V3.53955' stroke='#33322F' strokeWidth='1.13' strokeLinecap='round' strokeLinejoin='round'/>
// 		</svg>

// 	)
// }

export function EmailOutlookCardIcon({ makeBold }) {
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.63725 7.03906C6.03879 7.03906 6.38084 6.88906 6.68324 6.59406C6.97572 6.28906 7.12444 5.94406 7.12444 5.53906C7.12444 5.13406 6.97572 4.78906 6.68324 4.48406C6.38084 4.18906 6.03879 4.03906 5.63725 4.03906C5.2357 4.03906 4.89365 4.18906 4.59125 4.48406C4.29877 4.78906 4.15005 5.13406 4.15005 5.53906C4.15005 5.94406 4.29877 6.28906 4.59125 6.59406C4.89365 6.88906 5.2357 7.03906 5.63725 7.03906ZM5.63725 0.539062C7.00051 0.539062 8.16548 1.03906 9.13215 2.01406C10.0988 2.98906 10.5946 4.16406 10.5946 5.53906V6.26406C10.5946 6.76406 10.4211 7.18906 10.0988 7.53906C9.75182 7.87406 9.35523 8.03906 8.8595 8.03906C8.26462 8.03906 7.77385 7.78906 7.40205 7.28906C6.90632 7.78906 6.32136 8.03906 5.63725 8.03906C4.95809 8.03906 4.37313 7.78906 3.88236 7.30906C3.40645 6.81406 3.15859 6.22906 3.15859 5.53906C3.15859 4.85406 3.40645 4.26406 3.88236 3.76906C4.37313 3.28906 4.95809 3.03906 5.63725 3.03906C6.32136 3.03906 6.90136 3.28906 7.39214 3.76906C7.86804 4.26406 8.1159 4.85406 8.1159 5.53906V6.26406C8.1159 6.46906 8.19522 6.64906 8.34394 6.80406C8.49266 6.95906 8.66617 7.03906 8.8595 7.03906C9.06771 7.03906 9.24121 6.95906 9.38993 6.80406C9.53865 6.64906 9.6031 6.46906 9.6031 6.26406V5.53906C9.6031 4.44406 9.22138 3.50406 8.43813 2.71406C7.65487 1.92406 6.7229 1.53906 5.63725 1.53906C4.55159 1.53906 3.61962 1.92406 2.83636 2.71406C2.05311 3.50406 1.67139 4.44406 1.67139 5.53906C1.67139 6.63406 2.05311 7.57406 2.83636 8.36406C3.61962 9.15406 4.55159 9.53906 5.63725 9.53906H8.1159V10.5391H5.63725C4.27398 10.5391 3.10902 10.0391 2.14234 9.06406C1.17566 8.08906 0.679932 6.91406 0.679932 5.53906C0.679932 4.16406 1.17566 2.98906 2.14234 2.01406C3.10902 1.03906 4.27398 0.539062 5.63725 0.539062Z"
        fill={makeBold ? '#33322F' : '#93918F'}
        stroke={makeBold ? '#33322F' : '#93918F'}
        strokeWidth={makeBold ? '0.5' : '.3'}
      />
    </svg>
  );
}

export function OutlookCardEditIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.16455 2.32129L10.4146 4.57129"
        stroke="#93918F"
        strokeWidth="1.06409"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16455 8.32031L4.41455 10.5703"
        stroke="#93918F"
        strokeWidth="1.06409"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.66455 0.820312L11.9145 3.07031L4.41455 10.5703L1.41455 11.3203L2.16455 8.32031L9.66455 0.820312Z"
        stroke="#93918F"
        strokeWidth="1.06409"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowForward() {
  return (
    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.8787 7.07984C13.2054 6.75318 13.2054 6.22651 12.8787 5.89984L7.33874 0.359844C7.07874 0.0998437 6.65874 0.0998437 6.39874 0.359844L0.858739 5.89984C0.532072 6.22651 0.532072 6.75318 0.858739 7.07984C1.18541 7.40651 1.71207 7.40651 2.03874 7.07984L6.87207 2.25318L11.7054 7.08651C12.0254 7.40651 12.5587 7.40651 12.8787 7.07984Z"
        fill="#93918F"
      />
    </svg>
  );
}

export function ArrowBackward() {
  return (
    <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.24802 0.414789C0.885663 0.777145 0.885663 1.36135 1.24802 1.72371L7.39329 7.86898C7.6817 8.15738 8.14758 8.15738 8.43599 7.86898L14.5813 1.72371C14.9436 1.36135 14.9436 0.777145 14.5813 0.414789C14.2189 0.0524323 13.6347 0.0524323 13.2723 0.414789L7.91094 5.76879L2.54955 0.407394C2.19458 0.0524323 1.60298 0.0524325 1.24802 0.414789Z"
        fill="#93918F"
      />
    </svg>
  );
}

export function MailBox({ makeBold }) {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={makeBold ? '#33322F' : '#93918F'}
        stroke={makeBold ? '#33322F' : '#93918F'}
        strokeWidth={makeBold ? '.7' : '.5'}
        d="M14,12.85V6.85H18V8.85H16V12.85H14M18,3.85H8A5,5 0 0,0 3,8.85V17.85H1V19.85H21A2,2 0 0,0 23,17.85V8.85A5,5 0 0,0 18,3.85M11,17.85H5V8.85A3,3 0 0,1 8,5.85A3,3 0 0,1 11,8.85V17.85M21,17.85H13V8.85C13,7.76 12.65,6.71 12,5.85H18A3,3 0 0,1 21,8.85V17.85Z"
      />
    </svg>
  );
}

export const ReqOutlookCardDownloadIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="9.6" height="9.6" transform="translate(1.2 1.47949)" fill="#F9F8F7" />
      <path
        d="M10.8 7.87939V10.0127C10.8 10.2956 10.6876 10.5669 10.4876 10.767C10.2875 10.967 10.0162 11.0794 9.73334 11.0794H2.26667C1.98377 11.0794 1.71246 10.967 1.51242 10.767C1.31239 10.5669 1.2 10.2956 1.2 10.0127V7.87939"
        stroke="#EEA61A"
        strokeWidth="1.01909"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33336 5.21289L6.00003 7.87956L8.66669 5.21289"
        stroke="#EEA61A"
        strokeWidth="1.01909"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 7.87949V1.47949"
        stroke="#EEA61A"
        strokeWidth="1.01909"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const InPersonVendorIcon = ({ makeBold }) => {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.0812 10.7295V9.72949C10.0812 9.19906 9.87232 8.69035 9.50045 8.31528C9.12858 7.94021 8.62422 7.72949 8.09831 7.72949H4.13246C3.60656 7.72949 3.10219 7.94021 2.73032 8.31528C2.35845 8.69035 2.14954 9.19906 2.14954 9.72949V10.7295"
        stroke={`${makeBold ? '#33322F' : '#93918F'}`}
        strokeWidth={`${makeBold ? '1.4' : '1.1'}`}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.11549 5.729C7.21063 5.729 8.09842 4.83357 8.09842 3.729C8.09842 2.62443 7.21063 1.729 6.11549 1.729C5.02035 1.729 4.13257 2.62443 4.13257 3.729C4.13257 4.83357 5.02035 5.729 6.11549 5.729Z"
        stroke={`${makeBold ? '#33322F' : '#93918F'}`}
        strokeWidth={`${makeBold ? '1.4' : '1.1'}`}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PropertiesPlusIcon = () => {
  return (
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.1646 0.70459V17.1692"
        stroke="#EEA61A"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8539 8.93689H1.47461"
        stroke="#EEA61A"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PropertiesMinusIcon = () => {
  return (
    <svg width="20" height="2" viewBox="0 0 20 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.8525 0.93689H1.47314"
        stroke="#EEA61A"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowUp = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.33365 8.00293L12.667 8.00293"
        stroke="#F9F8F7"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00032 3.33594L12.667 8.00261L8.00032 12.6693"
        stroke="#F9F8F7"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ErrorIconSmall = () => {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path
          d="M4.66645 8.62049C6.81326 8.62049 8.55359 6.88015 8.55359 4.73334C8.55359 2.58653 6.81326 0.846191 4.66645 0.846191C2.51963 0.846191 0.779297 2.58653 0.779297 4.73334C0.779297 6.88015 2.51963 8.62049 4.66645 8.62049Z"
          stroke="#C50E29"
          strokeWidth="0.774538"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.66699 3.17871V4.73357"
          stroke="#C50E29"
          strokeWidth="0.774538"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.66699 6.28809H4.67096"
          stroke="#C50E29"
          strokeWidth="0.774538"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="9.32916" height="9.32916" fill="white" transform="translate(0.00195312 0.0683594)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PopOut = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <rect width="16" height="16" transform="translate(0.998047 0.500977)" fill="#F9F8F7" />
        <path
          d="M13.8252 9.30319V14.088C13.8252 14.511 13.6572 14.9166 13.3581 15.2158C13.059 15.5149 12.6533 15.6829 12.2303 15.6829H3.45821C3.03521 15.6829 2.62953 15.5149 2.33042 15.2158C2.03132 14.9166 1.86328 14.511 1.86328 14.088V5.31587C1.86328 4.89287 2.03132 4.4872 2.33042 4.18809C2.62953 3.88898 3.03521 3.72095 3.45821 3.72095H8.24299"
          stroke="currentColor" //"#93918F"
          strokeWidth="1.87384"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3965 1.32886H16.1813V6.11364"
          stroke="currentColor" //"#93918F"
          strokeWidth="1.87384"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.41211 10.101L16.1842 1.32886"
          stroke="currentColor" //"#93918F"
          strokeWidth="1.87384"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white" transform="translate(0.998047 0.500977)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FormIcon = () => {
  return (
    <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 3.50098H15L13.5 5.50098L12 3.50098ZM2 0.500977H16C17.11 0.500977 18 1.40098 18 2.50098V18.501C18 19.611 17.11 20.501 16 20.501H2C0.9 20.501 0 19.611 0 18.501V2.50098C0 1.40098 0.9 0.500977 2 0.500977ZM2 2.50098V6.50098H16V2.50098H2ZM2 18.501H16V8.50098H2V18.501ZM4 10.501H14V12.501H4V10.501ZM4 14.501H14V16.501H4V14.501Z"
        fill="currentColor" //"#93918F"
      />
    </svg>
  );
};

export const BackCurvedIcon = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path
        d="M5.89337 9.91418L1.57227 5.59307L5.89337 1.27197"
        stroke="currentColor"
        strokeWidth="1.72844"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3998 15.1002V9.05063C15.3998 8.13381 15.0356 7.25454 14.3873 6.60625C13.739 5.95796 12.8597 5.59375 11.9429 5.59375H1.57227"
        stroke="currentColor"
        strokeWidth="1.72844"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="15.9983" height="15.9983" fill="white" transform="translate(0.449219 0.184082)" />
      </clipPath>
    </defs>
  </svg>
);

export function OutlookNotesIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path
          d="M7.36719 1.07812H3.36719C3.10197 1.07813 2.84762 1.18348 2.66008 1.37102C2.47254 1.55855 2.36719 1.81291 2.36719 2.07813V10.0781C2.36719 10.3433 2.47254 10.5977 2.66008 10.7852C2.84762 10.9728 3.10197 11.0781 3.36719 11.0781H9.36719C9.6324 11.0781 9.88676 10.9728 10.0743 10.7852C10.2618 10.5977 10.3672 10.3433 10.3672 10.0781V4.07813L7.36719 1.07812Z"
          stroke="#93918F"
          strokeWidth="1.02022"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.36719 1.07812V4.07812H10.3672"
          stroke="#93918F"
          strokeWidth="1.02022"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.36719 6.57812H4.36719"
          stroke="#93918F"
          strokeWidth="1.02022"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.36719 8.57812H4.36719"
          stroke="#93918F"
          strokeWidth="1.02022"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.36719 4.57812H4.86719H4.36719"
          stroke="#93918F"
          strokeWidth="1.02022"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="12" height="12" fill="white" transform="translate(0.367188 0.078125)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function OutlookNotesIconRed() {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path
          d="M7.94043 1.26074H3.94043C3.67521 1.26074 3.42086 1.3661 3.23332 1.55364C3.04579 1.74117 2.94043 1.99553 2.94043 2.26074V10.2607C2.94043 10.526 3.04579 10.7803 3.23332 10.9678C3.42086 11.1554 3.67521 11.2607 3.94043 11.2607H9.94043C10.2056 11.2607 10.46 11.1554 10.6475 10.9678C10.8351 10.7803 10.9404 10.526 10.9404 10.2607V4.26074L7.94043 1.26074Z"
          stroke="#FADEAE"
          strokeWidth="1.02022"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.94043 1.26074V4.26074H10.9404"
          stroke="#FADEAE"
          strokeWidth="1.02022"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.94043 6.76074H4.94043"
          stroke="#FADEAE"
          strokeWidth="1.02022"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.94043 8.76074H4.94043"
          stroke="#FADEAE"
          strokeWidth="1.02022"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.94043 4.76074H5.44043H4.94043"
          stroke="#FADEAE"
          strokeWidth="1.02022"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="12" height="12" fill="white" transform="translate(0.94043 0.260742)" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function ClockIcon() {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00001 15.0833C11.6819 15.0833 14.6667 12.0986 14.6667 8.41667C14.6667 4.73477 11.6819 1.75 8.00001 1.75C4.31811 1.75 1.33334 4.73477 1.33334 8.41667C1.33334 12.0986 4.31811 15.0833 8.00001 15.0833Z"
        stroke="#93918F"
        strokeWidth="1.32606"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 4.41663V8.41663L10.6667 9.74996"
        stroke="#93918F"
        strokeWidth="1.32606"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
